import { WifiOff, CloudOff, Loader2, CheckCircle } from "lucide-react";
import { useOnlineStatus } from "@/hooks/useOffline";
import { useOfflineMutationQueue } from "@/hooks/useOfflineMutations";
import { m, AnimatePresence } from "framer-motion";

export function OfflineBanner() {
  const isOnline = useOnlineStatus();
  const { syncState } = useOfflineMutationQueue();

  const showSyncing = isOnline && syncState.isSyncing;
  const showPending = !isOnline && syncState.pendingCount > 0;

  return (
    <AnimatePresence>
      {(!isOnline || showSyncing) && (
        <m.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className={
            showSyncing
              ? "bg-blue-500/10 border-b border-blue-500/20 overflow-hidden"
              : "bg-amber-500/10 border-b border-amber-500/20 overflow-hidden"
          }
        >
          <div className="flex items-center justify-center gap-2 py-2 px-4 text-sm">
            {showSyncing ? (
              <>
                <Loader2 className="h-4 w-4 animate-spin text-blue-400" />
                <span className="text-blue-400">Syncing your changes...</span>
              </>
            ) : showPending ? (
              <>
                <CloudOff className="h-4 w-4 text-amber-400" />
                <span className="text-amber-400">
                  Offline — {syncState.pendingCount} change{syncState.pendingCount !== 1 ? "s" : ""} queued
                </span>
              </>
            ) : (
              <>
                <WifiOff className="h-4 w-4 text-amber-400" />
                <span className="text-amber-400">You're offline. Showing cached data.</span>
              </>
            )}
          </div>
        </m.div>
      )}

      {syncState.lastSyncError && isOnline && !syncState.isSyncing && (
        <m.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          className="bg-red-500/10 border-b border-red-500/20 overflow-hidden"
        >
          <div className="flex items-center justify-center gap-2 py-2 px-4 text-sm text-red-400">
            <CloudOff className="h-4 w-4" />
            <span>{syncState.lastSyncError}</span>
          </div>
        </m.div>
      )}
    </AnimatePresence>
  );
}
